import { render, staticRenderFns } from "./casedescription.vue?vue&type=template&id=d4baeb1a&scoped=true"
import script from "./casedescription.vue?vue&type=script&lang=js"
export * from "./casedescription.vue?vue&type=script&lang=js"
import style0 from "./casedescription.vue?vue&type=style&index=0&id=d4baeb1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4baeb1a",
  null
  
)

export default component.exports